import { SET_COOKIE } from 'constants/reduxActions';
import {
  MAFIA_SESSION_ID,
  MAFIA_SESSION_TOKEN,
  MAFIA_UBID_MAIN
} from 'constants/apis';
import { cookieDomain } from 'cfg/marketplace.json';

export function sessionExpiration() {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 20);
  date.setMonth(0);
  date.setDate(1); // the only 1-indexed setter..
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
}

export const setSessionCookies = dispatch => responseHeaders => {
  // this session is valid, or not new - so don't set cookies
  if (responseHeaders.get(MAFIA_SESSION_TOKEN)) {
    return;
  }

  const sessionId = responseHeaders.get(MAFIA_SESSION_ID);
  const ubidMain = responseHeaders.get(MAFIA_UBID_MAIN);
  const expiration = sessionExpiration();
  if (sessionId && ubidMain) {
    dispatch(setAndStoreCookie('session-id', sessionId, expiration));
    dispatch(setAndStoreCookie('ubid-main', ubidMain, expiration));
  }
};

// This is the action creator, to do a raw cookie set see helpers#setCookie
export function setAndStoreCookie(cookieName, cookieValue, expires) {
  return {
    type: SET_COOKIE,
    cookie: {
      name: cookieName,
      value: cookieValue,
      options: {
        domain: cookieDomain,
        expires
      }
    }
  };
}
